import { css } from 'styled-components'

export const getColumnDirectionCss = (reverseColumns?: boolean) => {
  return css`
    display: flex;
    flex-direction: ${reverseColumns ? 'column-reverse' : 'column'};
    grid-template-columns: auto;
  `
}
